"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseMeetingPriceTierWithFee = void 0;
/**
 * @deprecated
 * @see CPriceTier
 */
var BaseMeetingPriceTierWithFee = /** @class */function () {
  function BaseMeetingPriceTierWithFee(priceTier, fee) {
    this.id = priceTier.id;
    this.amount_eur = parseFloat(priceTier.amount_eur.toString());
    this.amount_usd = parseFloat(priceTier.amount_usd.toString());
    this.amount_rur = parseFloat(priceTier.amount_rur.toString());
    this.is_enabled = priceTier.is_enabled;
    this.fee = fee;
    this.fee_eur = this.amount_eur * fee;
    this.fee_usd = this.amount_usd * fee;
    this.fee_rur = this.amount_rur * fee;
    this.total_eur = this.amount_eur + this.fee_eur;
    this.total_usd = this.amount_usd + this.fee_usd;
    this.total_rur = this.amount_rur + this.fee_rur;
  }
  return BaseMeetingPriceTierWithFee;
}();
exports.BaseMeetingPriceTierWithFee = BaseMeetingPriceTierWithFee;
